import { MobileBottomNavigationContainer, Provider } from '@cian/frontend-mobile-bottom-navigation';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { selectPage, selectUser } from '../../selectors';
import { selectLocationId } from '../../selectors/locationId';
import { useApplicationContext } from '../../utils/applicationContext';

export const BottomNavigationContainer = () => {
  const { httpApi, logger, config } = useApplicationContext();
  const { subdomain } = useSelector(selectPage);
  const { isAuthenticated } = useSelector(selectUser);
  const locationId = useSelector(selectLocationId);

  const isMobileBottomNavigationFromHeaderEnabled =
    config.get<boolean>('header-frontend.mobileBottomNavigation.Enabled') ?? false;

  const isMobileBottomNavigationEnabled = config.get<boolean>('mobileBottomNavigation.Enabled') ?? false;

  if (isMobileBottomNavigationFromHeaderEnabled || !isMobileBottomNavigationEnabled) {
    return null;
  }

  return (
    <Provider context={{ httpApi, logger, config }}>
      <MobileBottomNavigationContainer
        pageType="favorites"
        subdomain={subdomain}
        region={locationId}
        isAuthenticated={isAuthenticated}
      />
    </Provider>
  );
};
